import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Swiper from "swiper/bundle";
import 'swiper/css';
import 'swiper/css/navigation';
import imagesLoaded from "imagesloaded";
import GLightbox from 'glightbox';
import 'glightbox/dist/css/glightbox.min.css';

require('fslightbox');
gsap.registerPlugin(ScrollTrigger);

const lightbox = GLightbox({
  selector: '.glightbox',
  touchNavigation: true,
  loop: true,
});

var searchToggle = document.querySelector('#searchToggle');
const search = document.querySelector('.m-search');
if (searchToggle) {
  searchToggle.addEventListener('click', function() {
    const searchBox = document.querySelector('.u-overlay--search');
    searchBox.classList.add('is-visible');
    const overlay = document.querySelector('.u-overlay--search.is-visible');
    overlay.addEventListener('click', function(event) {
      if(event.target === this) {
        overlay.classList.remove('is-visible');
      }
    })
  });
}

var shareToggle = document.querySelector('#shareToggle');
var shareClose = document.querySelector('.u-overlay__close');
const shareBox = document.querySelector('.u-overlay--share');
if (shareBox) {  
  shareToggle.addEventListener('click', function() {
    shareBox.classList.add('is-visible');

    const overlay = document.querySelector('.u-overlay--share.is-visible');
    overlay.addEventListener('click', function(event) {
      if(event.target === this) {
        overlay.classList.remove('is-visible');
      }
    })
  });
  shareClose.addEventListener('click', function() {
    shareBox.classList.remove('is-visible');
  })
}

var diveDeeperBtn = document.querySelector('.button--dive');
if(diveDeeperBtn) {
  diveDeeperBtn.onclick = function(){
    const element = document.getElementById("anglerfish");
    element.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
  }
}

var moreHotelsBtn = document.querySelector('.m-morebuttons__hotels');
if(moreHotelsBtn) {
  if(!document.querySelector(".m-more__hotels")) {
    moreHotelsBtn.style.display = 'none';
  }
  moreHotelsBtn.onclick = function(){
    const element = document.querySelector(".m-more__hotels");
    element.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
    return false;
  }
}

var moreCentersBtn = document.querySelector('.m-morebuttons__centers');
if(moreCentersBtn) {
  if(!document.querySelector(".m-more__centers")) {
    moreCentersBtn.style.display = 'none';
  }
  moreCentersBtn.onclick = function(){
    const element = document.querySelector(".m-more__centers");
    element.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
    return false;
  }
}

var moreSafarisBtn = document.querySelector('.m-morebuttons__safaris');
if(moreSafarisBtn) {
  if(!document.querySelector(".u-limiter--safaris")) {
    moreSafarisBtn.style.display = 'none';
  }
  moreSafarisBtn.onclick = function(){
    const element = document.querySelector(".u-limiter--safaris");
    element.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
    return false;
  }
}

var moreKachelnBtn = document.querySelector('.m-morebuttons__kacheln');
if(moreKachelnBtn) {
  if(!document.querySelector(".m-more__kacheln")) {
    moreKachelnBtn.style.display = 'none';
  }
  moreKachelnBtn.onclick = function(){
    const element = document.querySelector(".m-more__kacheln");
    element.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
    return false;
  }
}

/* 
*****
  grid navigation for destinations (not mobile)
*****
*/

var destinationNav = document.querySelector('.destinationNav');
if(destinationNav) {
  destinationNav.onmouseover = function(){
    var parent = destinationNav.parentNode.parentNode;

    if(!parent.classList.contains('is-visible')){
      // TODO: Mobile Navigation
    
      resizeAllGridItems();
    }

  }
}

function resizeGridItem(item){
  var grid = document.getElementsByClassName("m-destinations")[0];
  var rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'));
  var rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-row-gap'));
  var rowSpan = Math.ceil((item.querySelector('.m-box__content').getBoundingClientRect().height+rowGap)/(rowHeight+rowGap));
  item.style.gridRowEnd = "span "+rowSpan;
}

function resizeAllGridItems(){
  allItems = document.getElementsByClassName("m-box");
  for(var x=0;x<allItems.length;x++){
    resizeGridItem(allItems[x]);
  }
}

function resizeInstance(instance){
  var item = instance.elements[0];
  resizeGridItem(item);
}

window.onload = resizeAllGridItems();
window.addEventListener("resize", resizeAllGridItems);

var allItems = document.getElementsByClassName("m-box");
for(var x=0;x<allItems.length;x++){
  imagesLoaded( allItems[x], resizeInstance);
}
/* 
*****
  end:grid navigation for destinations 
*****
*/

/*
  Info-box darkblue click
*/
var infoBox = document.querySelector('.info-box.star');
if(infoBox) {
  infoBox.addEventListener('click', function(e) {
    e.preventDefault();
    infoBox.classList.toggle('is-visible'); // or whatever your active class is
  });
}

/**
 * Mobile Nav
 */

/*var mobileNav = document.querySelector('#showNav');
if(mobileNav) {
  mobileNav.addEventListener('click', function(e) {
      var mainMenu = document.querySelector('.m-navigation');
      e.preventDefault();
      mobileNav.classList.toggle('is-clicked'); // or whatever your active class is
      mainMenu.classList.toggle('is-visible'); // or whatever your active class is
  });
}*/

var mobileNav = document.querySelector('#showNav');
if(mobileNav) {
  mobileNav.addEventListener('click', function(e) {
      var mainMenu = document.querySelector('.m-navigation');
      e.preventDefault();
      mobileNav.classList.toggle('is-clicked'); // or whatever your active class is
      mainMenu.classList.toggle('is-visible'); // or whatever your active class is
  });
}

const navExpand = document.querySelectorAll('.nav-expand');

navExpand.forEach(item => {
  item.querySelector('.nav-link').addEventListener('click', function (e) { 
    e.preventDefault();
    if(item.classList.contains("active")) {
      item.classList.remove('active'); 
    } else {
      item.classList.add('active'); 
    }
    return false;
  });
});

/**
 * Swipers
 */
// Swiper Page Gallery / Hotel Gallery
var homeswiper = new Swiper(".m-homeslider .swiper-container", {
    spaceBetween: 30,
    loop: false,
    navigation: { },
    pagination: { },

    on: {
      // start video if it is a video
      init: function(){
        var activeIndex = this.activeIndex;
        var activeSlide = document.getElementsByClassName('swiper-slide')[activeIndex];
        if(activeSlide.tagName == 'VIDEO') {
          activeSlide.play();
        }
      
      },
    
    }
  });

// Swiper Page Gallery / Hotel Gallery
var galleryswiper = new Swiper(".m-slider .swiper-container", {
    slidesPerView: 1,
    spaceBetween: 15,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
      // Responsive breakpoints
      breakpoints: {
        // when window width is >= 420
        420: {
          slidesPerView: 1,
          slidesPerGroup: 1,
          spaceBetween: 15
        },
        // when window width is >= 768px
        768: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          spaceBetween: 30
        }
      }
  });

// Swiper Home News
var newsswiper = new Swiper(".m-cards--news .swiper-container", {
    slidesPerView: 1,
    spaceBetween: 15,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    // Responsive breakpoints
    breakpoints: {
      // when window width is >= 420
      500: {
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 15
      },
      // when window width is >= 768px
      769: {
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 30
      },
      // when window width is >= 1081px
      1081: {
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 20
      },
      // when window width is >= 1081px
      1921: {
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 30
      },
    }
  });

// Swiper Home Specials
var specialsswiper = new Swiper(".m-cards--specials .swiper-container", {
    slidesPerView: 1,
    spaceBetween: 15,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
      // Responsive breakpoints
      breakpoints: {
        500: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          spaceBetween: 15
        },
        769: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          spaceBetween: 20
        },
        // when window width is >= 1081px
        1081: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 20
        },
        // when window width is >= 1151px
        1921: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 30
        }
      }
  });

// Swiper Home Explore
var exploreswiper = new Swiper(".m-cards--explore .swiper-container", {
    slidesPerView: 1,
    spaceBetween: 15,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
      // Responsive breakpoints
      breakpoints: {
        // when window width is >= 421
        500: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          spaceBetween: 15
        },
        // when window width is >= 769px
        769: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          spaceBetween: 20
        },
        // when window width is >= 1081px
        1081: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 20
        },
        // when window width is >= 1151px
        1921: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 30
        }
      }
  });


// Swiper Home Friends
var firendsswiper = new Swiper(".m-cards--friends .swiper-container", {
    slidesPerView: 1,
    spaceBetween: 15,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
      // Responsive breakpoints
      breakpoints: {
        // when window width is >= 420
        500: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          spaceBetween: 15
        },
        // when window width is >= 769px
        769: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          spaceBetween: 20
        },
        // when window width is >= 1081px
        1081: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 20
        },
        // when window width is >= 1151px
        1921: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 30
        }
      }
  });

var body = document.getElementById('body');
var diver = document.getElementById('diver');
var height = body.getBoundingClientRect().height;
var windowHeight = window.innerHeight;
var delayedCall;
var delayedClass;

if(diver) {
  gsap.to(".u-diver", {
    scrollTrigger: {
      trigger: ".u-diver",
      start: "top 20%",
      end: height - 500,
      scrub: 6,
      onUpdate: self => {
        if(delayedCall) {
          delayedCall.kill();
        }

        if(delayedClass) {
          delayedClass.kill();
        }

        diver.classList.add('is-swimming');

        if (self.direction === 1) {
          delayedClass = gsap.delayedCall(.019, () => diver.classList.remove('swimming-up'));
        } else {
          delayedClass = gsap.delayedCall(.019, () => diver.classList.add('swimming-up'));
        }

        delayedCall = gsap.delayedCall(3, () => diver.classList.remove('is-swimming'));

      },
    },
    y: height - windowHeight - 1000,
  });
}


var windowWidth = window.innerWidth;
var shark = document.getElementById('shark');

if(shark) {
  var tween = gsap.to(".u-shark", {
    scrollTrigger: {
      trigger: ".u-shark",
      start: "-100% 85%",
      end: "bottom 100%",
      onLeaveBack: () => tween.stop,
    },
    x: () => innerWidth,
    xPercent: 150,
    repeat: -1,
    duration: 15,
    repeatDelay: 3.25,
    yoyo: true,
    ease: "none",
    onRepeat: function() {
      shark.classList.toggle('rotated');
      var position;
      position = Math.floor(Math.random() * (10 - 1 + 1) + 1 );
      switch (position) {
        
        case 1:
          shark.style.bottom =  '42.5rem';
          break;      
        case 2:
          shark.style.bottom =  '22.5rem';
          break;
        case 3:
          shark.style.bottom =  '60rem';
          break;
        case 4:
          shark.style.bottom =  '55em';
          break;
        case 5:
          shark.style.bottom =  '15rem';
          break;
        case 6:
          shark.style.bottom =  '20rem';
          break;
        case 7:
          shark.style.bottom =  '35rem';
          break;
        case 8:
          shark.style.bottom =  '50rem';
          break;
        case 9:
          shark.style.bottom =  '45rem';
          break;
        case 10:
          shark.style.bottom =  '40rem';
          break;

      }
    }
  });

  tween.seek(5);
}

if(document.querySelector('.fishswarm-front')) {
  var swarmTweenFront = gsap.to(".fishswarm-front", {
    x: 1200,
    y: 200,
    rotation: 20,
    duration: 2.5,
  });
  swarmTweenFront.pause();
}

if(document.querySelector('.fishswarm-back')) {
  var swarmTweenBack = gsap.to(".fishswarm-back", {
    x: 1200,
    y: -300,
    rotation: -20,
    duration: 2,
  });

  swarmTweenBack.pause();
}

const socials = document.querySelector('.u-grid__item--socials');
const fishswarmHover = document.querySelector('#fishswarm');
if(fishswarmHover != null) {

  fishswarmHover.onmouseover = function(){
    swarmTweenFront.resume();
    swarmTweenBack.resume();
    socials.classList.add('is-clickable');
  }
}

/*** Search and Filter Tauchsafari***/ 
document.addEventListener('DOMContentLoaded', function() {
  const mFilterForm = document.querySelector('.m-filter');
  if (!mFilterForm) return;

  const currentDate = new Date();

  let currentDay =  currentDate.getDate();

  //Februar
  if (currentDay > 28 ) {
    currentDay = 28
  }

  const startDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDay);
  const endDate = new Date(currentDate.getFullYear() + 4, currentDate.getMonth(), currentDay);
  const startDateSelect = document.getElementById('startDate');
  const finalDateSelect = document.getElementById('finalDate');
  const userLanguage = window.location.pathname.includes('/fr/') ? 'fr-FR' : 'de-DE';

  function fillSelectWithOptions(select, start, end, excludeBefore = null, limitMonths = null) {
      select.innerHTML = '';
      let count = 0;
      for(let date = new Date(start); date <= end; date.setMonth(date.getMonth() + 1)) {
          if (excludeBefore && date < excludeBefore) continue;
          if (limitMonths !== null && count >= limitMonths) break;
          const optionText = date.toLocaleDateString(userLanguage, { month: 'long', year: 'numeric' });
          const optionValue = `${date.getMonth() + 1}`.padStart(2, '0') + '.' + date.getFullYear();
          select.appendChild(new Option(optionText, optionValue));
          count++;
      }
  }

  function selectOptionByValue(selectElement, value) {
      const option = Array.from(selectElement.options).find(option => option.value === value);
      if (option){
        option.selected = true;
      } else {
        updateFinalDateSelect();
        const option = Array.from(selectElement.options).find(option => option.value === value);
        if (option){ 
          option.selected = true;
        }
      } 
  }

  function updateFinalDateSelect() {
      const selectedDateStr = startDateSelect.value.split(".");
      const selectedDate = new Date(selectedDateStr[1], parseInt(selectedDateStr[0]) - 1);

      const twoMonthsLater = new Date(selectedDate.getFullYear(), selectedDate.getMonth() + 2);
      fillSelectWithOptions(finalDateSelect, selectedDate, twoMonthsLater, null, 3);
  }

  fillSelectWithOptions(startDateSelect, startDate, endDate);
  updateFinalDateSelect();

  startDateSelect.addEventListener('change', updateFinalDateSelect);

  const queryParams = new URLSearchParams(window.location.search);
  selectOptionByValue(startDateSelect, queryParams.get('startDate'));
  selectOptionByValue(finalDateSelect, queryParams.get('finalDate'));

});

/** Specials Filter **/

document.addEventListener('DOMContentLoaded', function() {
  const mSpecials = document.querySelector('.special-index-page');
  if (!mSpecials) return;

  const currentDate = new Date();

  let currentDay =  currentDate.getDate();

  //Februar
  if (currentDay > 28 ) {
    currentDay = 28
  }

  const startDateSpecial = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDay);
  const endDateSpecial = new Date(currentDate.getFullYear() + 4, currentDate.getMonth(), currentDay);
  const startDateSelectSpecial = document.getElementById('startDateSpecial');
  const finalDateSelectSpecial = document.getElementById('finalDateSpecial');
  const userLanguageSpecial = window.location.pathname.includes('/fr/') ? 'fr-FR' : 'de-DE';

  function fillSelectWithOptions(select, start, end, excludeBefore = null, limitMonths = null) {
      select.innerHTML = '';
      let count = 0;
      for(let date = new Date(start); date <= end; date.setMonth(date.getMonth() + 1)) {
          if (excludeBefore && date < excludeBefore) continue;
          if (limitMonths !== null && count >= limitMonths) break;
          const optionText = date.toLocaleDateString(userLanguageSpecial, { month: 'long', year: 'numeric' });
          const optionValue = `${date.getMonth() + 1}`.padStart(2, '0') + '.' + date.getFullYear();
          select.appendChild(new Option(optionText, optionValue));
          count++;
      }
  }

  function selectOptionByValue(selectElement, value) {
      const option = Array.from(selectElement.options).find(option => option.value === value);
      if (option){
        option.selected = true;
      } else {
        updateFinalDateSelect();
        const option = Array.from(selectElement.options).find(option => option.value === value);
        if (option){ 
          option.selected = true;
        }
      } 
  }

  function updateFinalDateSelect() {
      const selectedDateStr = startDateSelectSpecial.value.split(".");
      const selectedDate = new Date(selectedDateStr[1], parseInt(selectedDateStr[0]) - 1);

      const twoMonthsLater = new Date(selectedDate.getFullYear(), selectedDate.getMonth() + 2);
      fillSelectWithOptions(finalDateSelectSpecial, selectedDate, twoMonthsLater, null, 3);
  }

  fillSelectWithOptions(startDateSelectSpecial, startDateSpecial, endDateSpecial);
  updateFinalDateSelect();

  startDateSelectSpecial.addEventListener('change', updateFinalDateSelect);

  const queryParams = new URLSearchParams(window.location.search);
  selectOptionByValue(startDateSelectSpecial, queryParams.get('startDateSpecial'));
  selectOptionByValue(finalDateSelectSpecial, queryParams.get('finalDateSpecial'));

});

//Tauchgebieten

document.addEventListener('DOMContentLoaded', () => {
  const mFilterForm = document.querySelector('.m-filter');
  if (!mFilterForm) return;

  const mFilterContainer = document.querySelector('.m-filter-container');

  if (mFilterContainer) {
    const targetDiv = document.getElementById("scroll-target");
    if (targetDiv) {
      targetDiv.scrollIntoView({ behavior: 'smooth' });
    }
  }

  const destinationSelect = document.getElementById('destination');
  const divingareaSelect = document.getElementById('divingarea');
  const boatareaSelect = document.getElementById('schiff');

  const savedOptions = Array.from(divingareaSelect.querySelectorAll('option'));
  const savedBoatOptions = Array.from(boatareaSelect.querySelectorAll('option'));

  const urlParams = new URLSearchParams(window.location.search);

  // Set selected options based on URL parameters
  const selectElements = [
    { id: "schiff", param: "schiff" },
    { id: "destination", param: "destination" },
    { id: "divingarea", param: "divingarea" }
  ];

  selectElements.forEach(select => {
    const selectElement = document.getElementById(select.id);
    const selectedValue = urlParams.get(select.param);
    if (selectedValue) {
      const options = selectElement.options;
      for (let i = 0; i < options.length; i++) {
        if (options[i].value === selectedValue) {
          options[i].selected = true;
          break;
        }
      }
    }
  });

  // Filter diving areas and preserve the selected value from URL
  const filterDivingAreas = (init = false) => {
    const selectedOption = destinationSelect.options[destinationSelect.selectedIndex];
    const selectedDestinationTitle = selectedOption.getAttribute('data-title') ?? '';

    divingareaSelect.innerHTML = '';

    const selectedDivingAreaParam = urlParams.get('divingarea') || 'all';

    savedOptions.forEach(option => {
      const destinations = option.getAttribute('data-destination') ?? '';
      if (selectedDestinationTitle === '' || destinations.includes(selectedDestinationTitle) || option.value === "all") {
        const clonedOption = option.cloneNode(true);
        if (clonedOption.value === selectedDivingAreaParam) {
          clonedOption.selected = true;
        }
        divingareaSelect.appendChild(clonedOption);
      }
    });
  };

  // Filter boats based on the selected destination
  const filterBoatAreas = (init = false) => {
    const selectedOption = destinationSelect.options[destinationSelect.selectedIndex];
    const selectedDestinationTitle = selectedOption.getAttribute('data-title') ?? '';
    boatareaSelect.innerHTML = '';

    if (init !== true) {
      savedBoatOptions.forEach(option => {
        boatareaSelect.appendChild(option.cloneNode(true));
      });
    } else {
      savedBoatOptions.forEach(option => {
        const boatDestinations = option.getAttribute('data-boatdestination') ?? '';
        if (boatDestinations.includes(selectedDestinationTitle) || option.value === "all") {
          boatareaSelect.appendChild(option.cloneNode(true));
        }
      });
    }
  };

  // Initialize diving areas based on URL parameters
  filterDivingAreas(true);

  // Update diving areas and boats when destination changes
  destinationSelect.addEventListener('change', () => {
    filterDivingAreas(false);
    if (destinationSelect.value != 'all') {
      filterBoatAreas(true);
    } else {
      filterBoatAreas(false);
    }
  });
});